import { FooterComponent } from 'app/layout/components/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalEventsComponent } from './portal-events.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PortalEventsHeaderModule } from './portal-events-header/portal-events-header.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@matheo/datepicker';
import { MatNativeDateModule } from '@matheo/datepicker/core';
import { PagedVirtualScrollerModule } from 'app/shared/components/paged-virtual-scroller/paged-virtual-scroller.module';


import { PortalEventsRoutingModule } from './portal-events-routing.module';

import { PortalEventsGQL } from 'app/shared/services/portal-events/graphql/portal-events.gql.service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { HardDeletePortalEventGQL, RestoreDeletedPortalEventGQL, SoftDeletePortalEventGQL } from 'app/shared/services/portal-events/graphql/portal-event-delete.gql.service';
import { PortalEventsHeaderResponsiveModule } from './portal-events-headerResponsive/portal-events-headerResponsive.module';
import { ToolbarHallsComponent } from 'app/layout/components/toolbar-halls/toolbar-halls.component';
import { CarouselBannerComponent } from 'app/shared/components/carousel-banner/carousel-banner.component';


@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    NgScrollbarModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    PortalEventsHeaderModule,
    PortalEventsHeaderResponsiveModule,
    PortalEventsRoutingModule,
    ToolbarHallsComponent,
    PagedVirtualScrollerModule,
    FooterComponent,
    CarouselBannerComponent,
    PortalEventsComponent
],
    providers: [
        PortalEventsGQL,
        RestoreDeletedPortalEventGQL,
        SoftDeletePortalEventGQL,
        HardDeletePortalEventGQL
    ]
})
export class PortalEventsModule { }
